import { GetStaticPropsContext } from 'next';

import { getStaticPaths as getPaths, getStaticProps as getProps } from '@backend';

import { Page, PageProps } from '@components/Page';

function SlugPage(pageProps: PageProps): JSX.Element {
  return <Page {...pageProps} />;
}

export async function getStaticPaths() {
  const paths = await getPaths();
  return paths;
}

export async function getStaticProps({ params, preview }: GetStaticPropsContext) {
  if (!params?.slug) return { notFound: true };

  const slugArray = Array.isArray(params.slug) ? params.slug : [params.slug];
  const props = await getProps(`/${slugArray.join('/')}`, preview);

  return props;
}

export default SlugPage;
